var VrEvents = function(params){
    var _this = this,
        _relatedSel = '#related',
        _bannerTopSel = '.view-banner-top',
        _containerWrapperSel = '.vr-container-wrapper',
        _defaultRelWidth = $(_relatedSel).outerWidth(true),
        _minRelWidth = 200;

    function _winResize(){

        /* TODO check for either banner top or banner bottom. */
        if($(_bannerTopSel).length === 0){
            return;
        }

        var relW = $(_relatedSel).outerWidth(true),
            newRelatedW = relW,
            bannerTopLeft = $(_bannerTopSel)[0].getBoundingClientRect().left + 10; /* Add buffer of 10px */

        if(bannerTopLeft < relW){
            newRelatedW = bannerTopLeft - 20;
        }else if(bannerTopLeft >= relW){
            newRelatedW = '';
        }

        if(bannerTopLeft < _minRelWidth){
            $(_relatedSel).hide();
            $(_containerWrapperSel).addClass('no-related');
        }else if($(_relatedSel).is(':visible') == false){
            $(_relatedSel).show();
            $(_containerWrapperSel).removeClass('no-related');
        }

        // $(_relatedSel).outerWidth(newRelatedW);
    }

    function _handleWindowResize(){        
        var _winResizeDebounced = dom.debounce(_winResize, 100);

        $(window).on('resize', _winResizeDebounced);

        _winResizeDebounced();
    }
    

    function _init(){
        _handleWindowResize();
    }

    _init();

    _this.init = _init;
};